import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'conexed-cookie-consent';

type Choice = 'accepted' | 'essential-only';

export function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem(STORAGE_KEY);
            if (v !== 'accepted' && v !== 'essential-only') setVisible(true);
        } catch {
            setVisible(true);
        }
    }, []);

    function record(choice: Choice) {
        try { localStorage.setItem(STORAGE_KEY, choice); } catch {}
        setVisible(false);
    }

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-labelledby="cookie-banner-title"
            aria-describedby="cookie-banner-desc"
            className="fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-gray-700 shadow-lg p-4"
        >
            <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-3">
                <div className="flex-1 text-sm text-gray-700 dark:text-gray-300">
                    <p id="cookie-banner-title" className="font-semibold text-gray-900 dark:text-white mb-1">
                        🍪 Cookies y privacidad
                    </p>
                    <p id="cookie-banner-desc">
                        Usamos cookies esenciales para autenticación y sesión. No usamos tracking de terceros.
                        {' '}
                        <Link to="/cookies" className="text-brand-blue hover:underline">Política de cookies</Link>
                        {' · '}
                        <Link to="/privacidad" className="text-brand-blue hover:underline">Privacidad</Link>
                    </p>
                </div>
                <div className="flex gap-2 flex-shrink-0">
                    <button
                        type="button"
                        onClick={() => record('essential-only')}
                        className="px-3 py-2 text-sm font-medium rounded-lg border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                        Solo esenciales
                    </button>
                    <button
                        type="button"
                        onClick={() => record('accepted')}
                        className="px-3 py-2 text-sm font-medium rounded-lg bg-brand-blue text-white hover:bg-brand-blue-dark"
                    >
                        Aceptar todo
                    </button>
                </div>
            </div>
        </div>
    );
}
